"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ACTIVE: 'active',
    DELETED: 'deleted',
    INACTIVE: 'inactive',
    DISABLED: 'disabled',
};
//# sourceMappingURL=userStatus.js.map